import React from 'react';
import BestTimeToPostTab from '../shared/BestTimeToPostTab';
import { LINKEDIN_PERSONAL_ACCOUNT } from '../../../config/constants';

const LinkedinPersonalAccountBestTimeToPostTab: React.FC = () => {
  return (
    <BestTimeToPostTab platforms={[LINKEDIN_PERSONAL_ACCOUNT]} />
  );
};

export default LinkedinPersonalAccountBestTimeToPostTab;
